<template>
  <div :class="getClassName">
    <div
      v-for="(item, index) in getSummary"
      :key="index"
      :class="getClassNameContainer"
    >
      <div :class="getClassName + 'Header'">
        {{ item.name }}
      </div>
      <div
        v-for="(attribute, indexS) in item.data"
        :key="indexS"
        :class="getClassNameItem"
      >
        {{ indexS }} - {{ attribute }}
      </div>
    </div>
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getSummary"]),
    name: () => {
      return "Summary";
    }
  }
};
</script>
